import { FastField, getIn } from "formik";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  TextField,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  formControl: {
    display: "flex",
    justifyContent: "center",
    minWidth: 120,
    "& .MuiSelect-select:focus": {
      backgroundColor: "unset",
    },
  },
  formControlReadOnly: {
    color: `${theme?.palette?.text?.disabled} !important`,
    borderColor: `${theme?.palette?.text?.disabled} !important`,
    "& .MuiInputBase-formControl": {
      color: `${theme?.palette?.text?.disabled} !important`,
    },
    "& .MuiFormLabel-root": {
      color: `${theme?.palette?.text?.disabled} !important`,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: `${theme?.palette?.text?.disabled} !important`,
    },
  },
  formControlDense: {
    "& legend": {
      display: "none",
    },
  },
}));

export function FormikSelect(props) {
  const {
    label,
    value,
    handleChange,
    required,
    options,
    readOnly,
    dense,
    isFastField,
    error,
    helperText,
  } = props;
  const classes = useStyles();
  const fastField = isFastField === undefined || isFastField;

  const name = props.name || props.id;
  const id = props.id || name;
  const formControlProps = props.formControlProps
    ? props.formControlProps
    : dense
      ? {
          fullWidth: true,
          variant: "outlined",
          margin: "dense",
          style: {
            marginBottom: "0",
            marginTop: "0",
          },
        }
      : {
          fullWidth: true,
          variant: "outlined",
          margin: "normal",
        };

  var selectProps = {
    native: true,
    value: value,
    onChange: handleChange,
    ...props.selectProps,
  };
  if (label) selectProps.label = label;

  var inputProps = {
    name: name,
    id: id,
  };
  if (required) {
    selectProps.required = required;
    inputProps.required = required;
  }

  if (readOnly) {
    inputProps.disabled = true;
    inputProps.inputProps = { readOnly: true };
  }

  const CustomOption = ({ opt, index }) => {
    var val =
      typeof opt === "string" || opt instanceof String
        ? opt
        : opt.value || index;
    var label =
      typeof opt === "string" || opt instanceof String
        ? opt
        : opt.label || opt.value || index;
    return (
      <option key={index} value={val}>
        {label}
      </option>
    );
  };

  const ReturnSelect = ({ meta }) => {
    var isError = meta ? Boolean(meta.touched && meta.error) : Boolean(error);
    return (
      <Select {...selectProps} inputProps={{ ...inputProps }} error={isError}>
        <option aria-label="None" value="" />
        {options.map((opt, index) => {
          if (typeof opt == "object" && opt.group) {
            return (
              <optgroup label={opt.group}>
                {opt.options &&
                  opt.options.map((childOpt, childIndex) => {
                    return (
                      <CustomOption
                        key={childIndex}
                        index={childIndex}
                        opt={childOpt}
                      />
                    );
                  })}
              </optgroup>
            );
          }

          return <CustomOption key={index} index={index} opt={opt} />;
        })}
      </Select>
    );
  };
  const ReturnControl = ({ meta }) => {
    var isError = meta ? Boolean(meta.touched && meta.error) : Boolean(error);

    var errorLabel =
      meta && Boolean(meta.touched && meta.error)
        ? meta.error
        : Boolean(error && helperText)
          ? helperText
          : "";
    return (
      <>
        <FormControl
          {...formControlProps}
          className={`${classes.formControl} ${
            readOnly ? classes.formControlReadOnly : ""
          } ${dense ? classes.formControlDense : ""}`}
        >
          {label && <InputLabel htmlFor={id}>{label}</InputLabel>}
          <ReturnSelect meta={meta} />
        </FormControl>
        {isError && <FormHelperText error>{errorLabel}</FormHelperText>}
      </>
    );
  };

  if (fastField) {
    return (
      <FastField name={name}>
        {({ field, form, meta }) => {
          return <ReturnControl meta={meta} />;
        }}
      </FastField>
    );
  } else {
    return <ReturnControl />;
  }
}

export function FormikTextField(props) {
  const {
    name,
    label,
    value,
    touched,
    errors,
    handleBlur,
    handleChange,
    variant,
    margin,
    fullWidth,
    required,
    type,
    inputProps,
    ...rest
  } = props;
  return (
    <TextField
      variant={variant || "outlined"}
      fullWidth={fullWidth || false}
      required={required || false}
      margin={margin || "normal"}
      type={type}
      onBlur={handleBlur}
      onChange={handleChange}
      label={label}
      name={name}
      value={value}
      error={Boolean(getIn(touched, name) && getIn(errors, name))}
      helperText={getIn(touched, name) && getIn(errors, name)}
      inputProps={inputProps}
      {...rest}
    />
  );
}

export function FormikContextHandler(props) {
  const { dirty, setDirty } = props;
  useEffect(() => {
    setDirty(dirty);
    // eslint-disable-next-line
  }, [dirty]);

  return <></>;
}
